const PATH = '/img/spareroom/v4/search/map/2x';
let domain = '';
let iconLanguage;

const createIconObject = (iconName) => ({
  url: `${domain}${PATH}/${iconName}.png`,
  size: {
    width: 40,
    height: 40,
  },
});

const createLocalisedIconObject = (iconName) => ({
  url:
    iconLanguage !== 'gb' && iconLanguage !== 'us'
      ? `${domain}${PATH}/${iconName}_${iconLanguage}.png`
      : `${domain}${PATH}/${iconName}.png`,
  size: {
    width: 40,
    height: 40,
  },
});

const icons = () => ({
  default: createIconObject('pin'),
  today: createLocalisedIconObject('today'),
  unsuitable: createIconObject('pin_unsuitable'),
  shortlist: createIconObject('pin_shortlist'),
  renewed_today: createLocalisedIconObject('pin_renewed_today'),
  new_today: createLocalisedIconObject('pin_new_today'),
  new: createLocalisedIconObject('pin_new'),
  interest: createIconObject('pin_interest'),
  contacted: createIconObject('pin_contacted'),
  super_renewed_today: createLocalisedIconObject('pin_boosted'),
});

const getIcons = (
  staticFilesServer = 'https://assets.spareroom.co.uk',
  country = 'gb',
) => {
  iconLanguage = country;
  domain = staticFilesServer;
  return icons();
};

export default getIcons;

/**
 * new/newness:
 * - New
 * - New Today
 * - Super Renewed Today
 *
 * context:
 * - unsuitable
 * - shorlist
 * - interest
 * - saved
 * - contacted
 *
 *
 *
 */
